import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, throwError, timer } from 'rxjs';
import { retry, catchError, retryWhen, mergeMap, tap } from 'rxjs/operators';
import { XWareLogService } from '../services/xware-log.service';

@Injectable({
  providedIn: 'root',
})
export class HttpErrorInterceptor implements HttpInterceptor {
  retryDelay = 2000;
  retryMaxAttempts = 2;
  constructor(private logger: XWareLogService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(this.retryAfterDelay());
  }

  retryAfterDelay(): any {
    return retryWhen(errors => {
      return errors.pipe(
        mergeMap((err, count) => {
          // throw error when we've retried ${retryMaxAttempts} number of times and still get an error
          this.logger.log('Error on HERERERE');
          this.logger.log('Error on ' + err.url);

          if (count === this.retryMaxAttempts || this.dontRetry(err)) {
            this.logger.log('HTTPError:' + JSON.stringify(err));
            sessionStorage.setItem(
              'SigUpdateError',
              JSON.stringify({ status: err.status, message: err.message })
            );

            return throwError(() => new Error(err));
          }
          return of(err).pipe(
            tap(error => this.logger.log(`Retrying ${error.url}. Retry count ${count + 1}`)),
            mergeMap(() => timer(this.retryDelay))
          );
        })
      );
    });
  }

  dontRetry(err): boolean {
    let bDontRetry = false;

    if (err.status === 413) {
      this.logger.log('HTTP Request StatusCode 413: Request timed out');
      if (err.url.indexOf('Designer/UpdateSignatureMany') > -1) {
        this.logger.log('HTTP Request StatusCode 413: UpdateSignatureMany');
        bDontRetry = true;
      }
    }

    if (err.url.indexOf('/Event/GetDefaultSignature') > -1) {
      bDontRetry = true;
    }
    if (err.url && (err.url.indexOf('/photo/$value') > -1 || err.url.indexOf('/getPhoto') > -1)) {
      bDontRetry = true;
    }
    if (err.url && err.url.indexOf('/Designer/LookupOverrideEnabled') > -1) {
      bDontRetry = true;
    }
    return bDontRetry;
  }
}
